export default "__VITE_ASSET__eiZEQUCF__"